import {
    SET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID,
    SET_APPROVAL_HIERARCHY_TABLE_EXCEL,
    SET_SAVE_APPROVAL_HIERARCHY,
    SET_SAVE_TITLE,
    SET_VALIDATE_TITLE,
    SET_IS_VALID_SKIP_APPROVAL,
    SET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID
} from "./ApprovalHierarhyType"

const initialState = {
    approvalHierarchyBySuperRegion: null,
    isApprovalHierarchySaved: null,
    isValidTitle: null,
    isValidSkipApproval: null
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID:
            return {
                ...state,
                approvalHierarchyBySuperRegion: action.approvalHierarchyBySuperRegion
            };
        case SET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID:
            return {
                ...state,
                additionalApprovalBySuperRegion: action.additionalApprovalBySuperRegion
            };
        case SET_SAVE_APPROVAL_HIERARCHY:
            return {
                ...state,
                isApprovalHierarchySaved: action.isApprovalHierarchySaved
            };
        case SET_VALIDATE_TITLE:
            return {
                ...state,
                isValidTitle: action.isValidTitle
            };
        case SET_SAVE_TITLE:
            return {
                ...state,
                isTitleSaved: action.isTitleSaved
            };
        case SET_APPROVAL_HIERARCHY_TABLE_EXCEL:
            return {
                ...state,
                approvalHierarchyTableExcel : action.approvalHierarchyTableExcel
            }
        case SET_IS_VALID_SKIP_APPROVAL:
            return {
                ...state,
                isValidSkipApproval: action.isValidSkipApproval
            }
        default:
            return state;
    }
};

export default reducer;